import { call, put, select, takeLatest } from 'redux-saga/effects';

import httpClient, { BaseUrl } from '../../utils/httpClient';
import { DELETE_MEDIA_REQUEST, POST_CREATE_REQUEST, SOCIAL_PAGES_GET_LIST_REQUEST, UPLOAD_REQUEST } from '../actions/actionTypes';
import { createPostError, createPostStore, socialPagesError, socialPagesRequest, socialPagesStore, uploadError } from '../actions/post';
import { setIsADraft } from '../actions/user';
import { addCustomsFiles, removeCustomsFile, removeFile, setStoreCustoms, storeFiles } from '../actions/wizard';
import { getCampaignId } from '../reducers/campaign';
import { getPosts } from '../reducers/integrations';
import { getCreatedPosts } from '../reducers/post';
import { getUserIsADraft, getUserIsAPublish } from '../reducers/user';
import { getCurrentCustomsId, getFiles, getIntegrations, getTextBody } from '../reducers/wizard';

// upload add
function getUploadApiCall(formData, profileId) {
  return httpClient.post(`api/profiles/${profileId}/campaigns/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

function getUploadApiCallVideo(formData, profileId) {
  return httpClient.post(`api/profiles/${profileId}/upload/video`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

function getUploadApiCallVideoThumbnail(url, profileId) {
  return httpClient.get(`api/profiles/${profileId}/video/thumbnail?url=${url}`);
}

function* uploadSaga({ payload }) {
  console.log('uploadSaga --->', payload);

  try {
    /* Declared for the whole saga, not inside the image branch: the customs step at the end reads it,
       and a video upload never entered that branch — so it threw on a variable that had never been
       created. */
    const uploadedImages = [];

    let formData = new FormData();

    payload.files.forEach((file, i) => {
      formData.append(i, file);
    });

    if (payload.type === 'video') {
      const { data } = yield call(getUploadApiCallVideo, formData, payload.profileId);

      if (data) {
        // const { data: dataThumbnail } = yield call(getUploadApiCallVideoThumbnail, data, payload.profileId);

        // console.log('dataThumbnail', dataThumbnail);

        uploadedImages.push({ url: data?.url, type: 'VIDEO', thumbnail: data?.thumbnail });
        yield put(storeFiles(uploadedImages));
      }
    } else {
      const { data } = yield call(getUploadApiCall, formData, payload.profileId);

      data.forEach((image) => {
        uploadedImages.push({ url: `${BaseUrl}/upload/${image}`, type: 'IMAGE', thumbnail: '' });
      });

      yield put(storeFiles(uploadedImages));
    }

    // const { data } = yield call(payload.type === 'video' ? getUploadApiCallVideo : getUploadApiCall, formData, payload.profileId);
    // const { dataThumbnail } = yield call(getUploadApiCallVideoThumbnail, data, payload.profileId);
    //
    // console.log('dataThumbnail', dataThumbnail);
    //
    // let uploadedImages = [];
    //
    // if (data && dataThumbnail) {
    //   console.log('push data');
    //   uploadedImages.push({ url: data, type: 'VIDEO', thumbnail: dataThumbnail });
    // }

    // uploadedImages.push({ url: data, type: 'VIDEO', thumbnail: dataThumbnail });
    // uploadedImages.map((x) => {
    //   // uploadedImages.push({ url: `${BaseUrl}/upload/${x}`, type: 'IMAGE', thumbnail: '' });
    //
    // });

    // yield put(storeFiles([{ url: data, type: 'VIDEO', thumbnail: dataThumbnail }]));

    const currentCustomsId = yield select(getCurrentCustomsId);

    if (currentCustomsId) {
      yield put(addCustomsFiles({ id: currentCustomsId, files: uploadedImages }));
    }
  } catch (error) {
    console.log('uploadSaga error', error.toString());

    yield put(uploadError(error.Message ? error.Message : error.toString()));
  }
}

export function* uploadWatcher() {
  yield takeLatest(UPLOAD_REQUEST, uploadSaga);
}

// upload remove
function getDeleteMediaApiCall({ postId, name, profileId }) {
  return httpClient.delete(`api/profiles/${profileId}/campaigns/media`, {
    data: {
      postId,
      name,
    },
  });
}

function* deleteMediaSaga({ payload }) {
  try {
    const name = payload.replace(`${BaseUrl}/upload/`, '');

    const currentCustomsId = yield select(getCurrentCustomsId);
    const createdPosts = yield select(getCreatedPosts);

    if (currentCustomsId && createdPosts.length) {
      const desiredPost = createdPosts.find((x) => x.type === currentCustomsId) || null;
      const postId = desiredPost.postId || 0;

      yield call(getDeleteMediaApiCall, { postId, name });
    }

    if (currentCustomsId) {
      yield put(removeCustomsFile({ id: currentCustomsId, file: payload }));
    }

    yield put(removeFile(payload));
  } catch (error) {
    console.log('deleteMediaSaga error', error.toString());
  }
}

export function* deleteMediaWatcher() {
  yield takeLatest(DELETE_MEDIA_REQUEST, deleteMediaSaga);
}

// create new
function getCreatePostApiCall(payload) {
  if (!payload.userIsAPublish) {
    return httpClient.post(`api/profiles/${payload.profileId}/campaigns/${payload.id}/posts`, {
      id: payload.id,
      message: payload.message,
      medias: payload.images,
    });
  } else {
    return httpClient.put(`api/profiles/${payload.profileId}/campaigns/${payload.id}/posts`, {
      id: payload.id,
      message: payload.message,
      medias: payload.images,
    });
  }
}

function* createPostSaga() {
  try {
    const id = yield select(getCampaignId);
    const message = yield select(getTextBody);
    const images = yield select(getFiles);
    const userIsAPublish = yield select(getUserIsAPublish);

    const payload = {
      id,
      message,
      medias: images.map((i) => i.replace(`${BaseUrl}/upload/`, '')),
      userIsAPublish: userIsAPublish,
    };

    const { data: createPostResp } = yield call(getCreatePostApiCall, payload);

    yield put(createPostStore(createPostResp));

    const integrations = yield select(getIntegrations);

    // create wizard customs for active integrations
    let createdCustoms = [];

    integrations.forEach((x) => {
      const postId = createPostResp.find((p) => p.type === x).postId || 0;

      createdCustoms.push({
        id: x,
        textBody: message,
        files: images,
        socialPageId: 0,
        postId: postId,
      });
    });

    yield put(setStoreCustoms(createdCustoms));
    const IsADraft = yield select(getUserIsADraft);

    if (IsADraft) {
      const posts = yield select(getPosts);

      yield put(setStoreCustoms(posts));
      yield put(setIsADraft(false));
    }

    yield put(socialPagesRequest(integrations));
  } catch (error) {
    console.log('createPostSaga error', error.toString());

    yield put(createPostError(error.Message ? error.Message : error.toString()));
  }
}

export function* createPostWatcher() {
  yield takeLatest(POST_CREATE_REQUEST, createPostSaga);
}

// social pages
function getSocialPagesApiCall(data, profileId) {
  return httpClient.post(`api/profiles/${profileId}/campaigns/pages`, data);
}

function* getSocialPagesSaga({ payload }) {
  try {
    const { data } = yield call(getSocialPagesApiCall, payload);

    yield put(socialPagesStore(data));
  } catch (error) {
    console.log('getSocialPagesSaga error', error.toString());

    yield put(socialPagesError(error.Message ? error.Message : error.toString()));
  }
}

export function* getSocialPagesWatcher() {
  yield takeLatest(SOCIAL_PAGES_GET_LIST_REQUEST, getSocialPagesSaga);
}
